import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { costumeApi } from "../api/costumeApi";

export const useCostumes = (params) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["costumes", params],
    queryFn: async () => await costumeApi.getAll(params),
    keepPreviousData: true,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 1,
    },
    isLoading,
    error,
    refetch,
  };
};

export const useCostume = (id) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["costume", id],
    queryFn: async () => await costumeApi.getById(id),
    enabled: !!id,
  });

  return {
    data: data || null,
    isLoading,
    error,
  };
};

export const useCostumeActions = () => {
  const queryClient = useQueryClient();

  const createCostume = useMutation({
    mutationFn: async (data) => await costumeApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["costumes"] });
    },
  });

  const updateCostume = useMutation({
    mutationFn: async ({ id, data }) => await costumeApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["costumes"] });
    },
  });

  const deleteCostume = useMutation({
    mutationFn: async (id) => await costumeApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["costumes"] });
    },
  });

  return {
    createCostume,
    updateCostume,
    deleteCostume,
  };
};
